let openImpl = null;

export const SessionExpiredDialogService = {
  open(options) {
    return openImpl ? openImpl(options) : Promise.resolve();
  },
  _register(fn) {
    openImpl = fn;
  },
};
